// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"CentralTable_spinnerContainer__aoI85","botonAdd":"CentralTable_botonAdd__xLRNp"};